export type TipoDocumento = 'CPF' | 'CNPJ';

export class SocioModel {
  constructor(
    public id: number | null,
    public nome: string,
    public cpfCnpj: string,
    public tipoDocumento: TipoDocumento,
    public dataNascimento: string | null,
    public nomePai: string | null,
    public nomeMae: string | null,
    public razaoSocial: string | null,
    public nomeReduzido: string | null,
    public dataFundacao: string | null,
  ) {}

  static fromJson(json: any): SocioModel {
    const doc = (json.cpfCnpj || '').replace(/\D/g, '');
    const tipo: TipoDocumento = json.tipoDocumento || (doc.length > 11 ? 'CNPJ' : 'CPF');
    return new SocioModel(
      json.id ?? null,
      json.nome || '',
      doc,
      tipo,
      json.dataNascimento || null,
      json.nomePai || null,
      json.nomeMae || null,
      json.razaoSocial || null,
      json.nomeReduzido || null,
      json.dataFundacao || null,
    );
  }

  toJson(): any {
    return {
      id: this.id,
      nome: this.nome,
      cpfCnpj: this.cpfCnpj,
      tipoDocumento: this.tipoDocumento,
      dataNascimento: this.dataNascimento,
      nomePai: this.nomePai,
      nomeMae: this.nomeMae,
      razaoSocial: this.razaoSocial,
      nomeReduzido: this.nomeReduzido,
      dataFundacao: this.dataFundacao,
    };
  }
}
